import { GridColDef } from '@mui/x-data-grid-pro';
import { useCommonDataGridSlotProps } from 'components/common/dataGrid/hooks/useCommonDataGridSlotProps';
import { UserOnView } from 'shared/domain/user/types/view';

interface UseUserDataGridSlotPropsOptions {
  columns: GridColDef<UserOnView>[];
}

export function useUserDataGridSlotProps({
  columns,
}: UseUserDataGridSlotPropsOptions) {
  return useCommonDataGridSlotProps({ columns });
}
